var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.999,
    height: 21,
    viewBox: "0 0 20.999 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Info_Icon",
    "data-name": "Info Icon",
    d: "M68.531,871a10.5,10.5,0,1,0-10.5-10.5A10.5,10.5,0,0,0,68.531,871Zm-1.683-16.68h3.264v7.661H66.847Zm1.632,9.193a1.762,1.762,0,1,1-1.762,1.762A1.762,1.762,0,0,1,68.48,863.512Z",
    transform: "translate(-58.031 -849.999)",
    fill: "#f2af00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.21ab8ace96d71340d24e6125b1ecf8a4.svg";
export { ForwardRef as ReactComponent };